import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FrontendConfig } from '../interfaces/frontend-config';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationStore {
  private readonly _config$: BehaviorSubject<FrontendConfig | null> = new BehaviorSubject<FrontendConfig | null>(null);
  private readonly STORAGE_KEY = 'portalConfig';

  constructor() {
    let initialValue = null;
    try {
      const stored = sessionStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        initialValue = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error restoring BU from sessionStorage', e);
    }

    this._config$ = new BehaviorSubject<FrontendConfig|null>(initialValue);
  }

  get config$(): Observable<FrontendConfig | null> {
    return this._config$.asObservable();
  }

  get config(): FrontendConfig | null {
    return this._config$.getValue();
  }

  set config(config: FrontendConfig | null) {
    if (config) {
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(config));
    } else {
      sessionStorage.removeItem(this.STORAGE_KEY);
    }
    this._config$.next(config);
  }
}
